export enum TableColumnType {
  Text,
  Integer,
  Float,
  Boolean,
  Currency,
  Tag,
  Link,
  Template,
  Selector
}
